/** @jsxImportSource @emotion/react */
import { useSelector } from "react-redux";
import * as authSelectors from "../auth/authSelectors";
import { TableRow } from "../../components/table-components/TableRow";
import { TableCellText } from "../../components/table-components/TableCellText";
import { firstTableCellStyle } from "../../style-util";
import { Avatar } from "../../components/Avatar";
import { StyledText } from "../../assets/typography/typography";
import { colors } from "../../components/colors";
import { formatMoneyAmount } from "../../util";
import { ShopProductsListDropdown } from "./ShopProductListDropdown";
import { routes } from "../../appRoutingHelpers";
import { css } from "@emotion/react";
import { ProductListItem } from "../products/models/product";

type Props = {
  product: ProductListItem;
  shopId: string;
};

const ellipsisWrapperStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: end;
  width: fit-content;
`;

const dropdownWrapperStyle = css`
  display: flex;
  align-items: center;
  height: 100%;
  flex-direction: row;
  gap: 8px;
  justify-content: end;
`;

export const ShopProductsListRow = ({ product, shopId }: Props) => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );

  return (
    <TableRow>
      <TableCellText css={firstTableCellStyle}>
        <Avatar size="small" imageUrl={product.imageUrl} rounded={true}>
          {product.name.charAt(0).toUpperCase()}
        </Avatar>
      </TableCellText>
      <TableCellText>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {product.name}
        </StyledText>
      </TableCellText>
      <TableCellText>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {product.categoryName}
        </StyledText>
      </TableCellText>
      <TableCellText>
        <StyledText className="bodyTextRegular mb-0" color={colors.textPrimary}>
          {formatMoneyAmount(product.price?.amount!, product.price?.currency!)}
        </StyledText>
      </TableCellText>
      <td css={dropdownWrapperStyle}>
        <div css={ellipsisWrapperStyle}>
          <ShopProductsListDropdown
            product={product}
            editLink={routes.productEdit(organizationKeyName, product.id)}
            shopId={shopId}
          />
        </div>
      </td>
    </TableRow>
  );
};
